var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"Representante/Vendedor","no-data-text":"Nenhuma opção disponível","items":_vm.vendedores,"item-value":"codigo","item-text":"nome","loading":_vm.loading},model:{value:(_vm.vendedorSelecModel),callback:function ($$v) {_vm.vendedorSelecModel=$$v},expression:"vendedorSelecModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }